import { parse, formatHex, oklch } from 'culori';
import { fontFamily } from '../constants.js';
import { palette } from '../palette/index.js';

const visuallyHiddenStyles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: 1,
    // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
    whiteSpace: "nowrap",
    wordWrap: "normal"
};
const truncateStyles = {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
};
const flex = (alignItems, justifyContent, gap)=>({
        display: "flex",
        alignItems,
        justifyContent,
        gap
    });
const noPrintStyles = {
    "@media print": {
        display: "none"
    }
};
const monospaceStyles = {
    fontFamily: fontFamily.mono,
    "--mono": "1"
};
const getIconFocusStateColor = ({ hasError, hasValue, isFocused })=>{
    if (hasError) {
        if (isFocused) {
            return hasValue ? palette.red10 : palette.red8;
        }
        return palette.red8;
    }
    return isFocused ? palette.gray14 : palette.gray10;
};
const convertOKLCHtoHex = (oklchColor)=>{
    const parsedColor = parse(oklchColor);
    return formatHex(oklch(parsedColor));
};

export { convertOKLCHtoHex, flex, getIconFocusStateColor, monospaceStyles, noPrintStyles, truncateStyles, visuallyHiddenStyles };
